import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import useStyle from './modal.style';
import { IconButton } from 'components/atoms/Buttons/IconButton';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';

export interface ModalViewProps {
  modalHead: string;
  children: ReactNode | ReactNode[];
  isShowing: boolean;
  width?: 'small' | 'medium' | 'cover' | 'laptop';
  onClose?: () => void;
  actionButton?: React.ReactNode;
}

export const ModalView = ({
  modalHead,
  onClose,
  isShowing,
  width = 'medium',
  children,
  actionButton
}: ModalViewProps) => {
  const classes = useStyle();
  if (!isShowing) return null;

  return ReactDOM.createPortal(
    <div className={classes.root}>
      <div className={`${classes.container} ${classes[width]}`}>
        <FeatureContainer
          buttonPosition="topRight"
          padding="small"
          iconButton={
            <IconButton onClick={onClose} icon="Close" variant="backless" />
          }
        >
          <span className={classes.modalHead}>{modalHead}</span>
          {children}
          {actionButton && <div onClick={onClose}>{actionButton}</div>}
        </FeatureContainer>
      </div>
    </div>,
    document.body
  );
};
